import { type RouteRecordRaw } from 'vue-router'

import { useFestivalStore } from '../festival/festival.store'
import { useGuestsStore } from '../guests/store/guests.store'
import { useProgramsStore } from '../programs/programs.store'
import { useScenesStore } from '../scenes/scenes.store'
import { useProgEventStore } from './progEvent.store'

export const ProgEventRouter: RouteRecordRaw[] = [
  {
    path: '/programmation',
    component: async () => import('./Programmation.vue'),

    async beforeEnter() {
      await Promise.all([
        useProgEventStore.getState().list(),
        useFestivalStore.getState().loadFestival(),
        useScenesStore.getState().list(),
        useProgramsStore.getState().list(),
        useGuestsStore.getState().getGuestsLight(),
      ])
    },
  },
  {
    path: '/programmation/create',
    component: async () => import('./AddingProgEvent.vue'),
  },
  {
    path: '/programmation/import',
    component: async () => import('./EventsImport.vue'),
  },
  {
    path: '/programmation/:id',
    component: async () => import('./AddingProgEvent.vue'),
    async beforeEnter(to) {
      await useProgEventStore.getState().loadProgEvent({
        id: to.params.id as string,
        loadType: 'edit',
      })
    },
  },
  {
    path: '/programmation/duplicate/:id',
    component: async () => import('./AddingProgEvent.vue'),
    async beforeEnter(to) {
      await useProgEventStore.getState().loadProgEvent({
        id: to.params.id as string,
        loadType: 'duplicate',
      })
    },
  },
]
